/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompaniesEntityRegistrationsListParams,
  EntityRegistration,
  EntityRegistrationCreateUpdateRequest,
  PaginatedEntityRegistrationList
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Get all entity registrations for the owner's company. Paginated.
 * @summary List entity registrations
 */
export const companiesEntityRegistrationsList = (
    params?: CompaniesEntityRegistrationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedEntityRegistrationList>(
      {url: `/api/v1/companies/entityRegistrations/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompaniesEntityRegistrationsListQueryKey = (params?: CompaniesEntityRegistrationsListParams,) => {
    return [`/api/v1/companies/entityRegistrations/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompaniesEntityRegistrationsListQueryOptions = <TData = Awaited<ReturnType<typeof companiesEntityRegistrationsList>>, TError = unknown>(params?: CompaniesEntityRegistrationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesEntityRegistrationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesEntityRegistrationsList>>> = ({ signal }) => companiesEntityRegistrationsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesEntityRegistrationsListQueryResult = NonNullable<Awaited<ReturnType<typeof companiesEntityRegistrationsList>>>
export type CompaniesEntityRegistrationsListQueryError = unknown

/**
 * @summary List entity registrations
 */
export const useCompaniesEntityRegistrationsList = <TData = Awaited<ReturnType<typeof companiesEntityRegistrationsList>>, TError = unknown>(
 params?: CompaniesEntityRegistrationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesEntityRegistrationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * ViewSet for Entity Registration - owner only, approved companies only.
 * @summary Create entity registration
 */
export const companiesEntityRegistrationsCreate = (
    entityRegistrationCreateUpdateRequest: EntityRegistrationCreateUpdateRequest,
 ) => {
      
      
      return customInstance<EntityRegistration>(
      {url: `/api/v1/companies/entityRegistrations/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: entityRegistrationCreateUpdateRequest
    },
      );
    }
  


export const getCompaniesEntityRegistrationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>, TError,{data: EntityRegistrationCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>, TError,{data: EntityRegistrationCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>, {data: EntityRegistrationCreateUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  companiesEntityRegistrationsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesEntityRegistrationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>>
    export type CompaniesEntityRegistrationsCreateMutationBody = EntityRegistrationCreateUpdateRequest
    export type CompaniesEntityRegistrationsCreateMutationError = unknown

    /**
 * @summary Create entity registration
 */
export const useCompaniesEntityRegistrationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>, TError,{data: EntityRegistrationCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesEntityRegistrationsCreate>>,
        TError,
        {data: EntityRegistrationCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesEntityRegistrationsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ViewSet for Entity Registration - owner only, approved companies only.
 * @summary Get entity registration
 */
export const companiesEntityRegistrationsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EntityRegistration>(
      {url: `/api/v1/companies/entityRegistrations/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getCompaniesEntityRegistrationsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/companies/entityRegistrations/${id}/`] as const;
    }

    
export const getCompaniesEntityRegistrationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompaniesEntityRegistrationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>> = ({ signal }) => companiesEntityRegistrationsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompaniesEntityRegistrationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>>
export type CompaniesEntityRegistrationsRetrieveQueryError = unknown

/**
 * @summary Get entity registration
 */
export const useCompaniesEntityRegistrationsRetrieve = <TData = Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompaniesEntityRegistrationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * ViewSet for Entity Registration - owner only, approved companies only.
 * @summary Update entity registration
 */
export const companiesEntityRegistrationsUpdate = (
    id: number,
    entityRegistrationCreateUpdateRequest: EntityRegistrationCreateUpdateRequest,
 ) => {
      
      
      return customInstance<EntityRegistration>(
      {url: `/api/v1/companies/entityRegistrations/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: entityRegistrationCreateUpdateRequest
    },
      );
    }
  


export const getCompaniesEntityRegistrationsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>, TError,{id: number;data: EntityRegistrationCreateUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>, TError,{id: number;data: EntityRegistrationCreateUpdateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>, {id: number;data: EntityRegistrationCreateUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  companiesEntityRegistrationsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesEntityRegistrationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>>
    export type CompaniesEntityRegistrationsUpdateMutationBody = EntityRegistrationCreateUpdateRequest
    export type CompaniesEntityRegistrationsUpdateMutationError = unknown

    /**
 * @summary Update entity registration
 */
export const useCompaniesEntityRegistrationsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>, TError,{id: number;data: EntityRegistrationCreateUpdateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesEntityRegistrationsUpdate>>,
        TError,
        {id: number;data: EntityRegistrationCreateUpdateRequest},
        TContext
      > => {

      const mutationOptions = getCompaniesEntityRegistrationsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * ViewSet for Entity Registration - owner only, approved companies only.
 * @summary Delete entity registration
 */
export const companiesEntityRegistrationsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/companies/entityRegistrations/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getCompaniesEntityRegistrationsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  companiesEntityRegistrationsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesEntityRegistrationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>>
    
    export type CompaniesEntityRegistrationsDestroyMutationError = unknown

    /**
 * @summary Delete entity registration
 */
export const useCompaniesEntityRegistrationsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companiesEntityRegistrationsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getCompaniesEntityRegistrationsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    